export default __webpack_public_path__ + "static/media/income-transaction.340751d8.svg";